<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field slot="lo_date"  :label="customLabel.lo_date || '申请日期'" v-model="form.main.lo_date" />
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="lo_class">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.lo_class || "借之类型"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.lo_class"
              placeholder="请选择"
            >
              <option>出差</option>
              <option>采购</option>
              <option>个人借支</option>
              <option>其它借支</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="lo_borrowamount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.lo_borrowamount || "借款金额"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.lo_borrowamount"
              placeholder="请输入借款金额"
            />
          </div>
        </div>
        <currency-field slot="lo_currency" :label="customLabel.lo_currency || '币种'" 
          v-model="form.main.lo_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell" slot="lo_receivedby">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.lo_receivedby || "收款人"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.lo_receivedby"
              placeholder="请输入收款人名称"
            />
          </div>
        </div>
        <div class="weui-cell" slot="lo_bank">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.lo_bank || "开户银行"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.lo_bank"
              placeholder="请输入开户银行"
            />
          </div>
        </div>
        <div class="weui-cell" slot="lo_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.lo_bankaccount || "银行账号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.lo_bankaccount"
              placeholder="请输入银行账号"
            />
          </div>
        </div>
        <div class="weui-cell" slot="lo_content">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.lo_content || '借款用途'"
              rows="3"
              v-model="form.main.lo_content"
              maxlength="100"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.lo_content ? form.main.lo_content.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
        <date-field slot="lo_predictreturndate"
          :label="customLabel.lo_predictreturndate || '预计归还日期'"
          v-model="form.main.lo_predictreturndate"
        />
      </custom-layout>

      <div class="weui-cells">
        <file-field v-model="form.main.lo_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    FileField,
    CurrencyField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/loan",
      codeField: "lo_code",
      statusField: "lo_statuscode",
      caller: "Loan",
      xtype: "oa-loan-formpanel",
      form: {
        main: {
          lo_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          lo_class: "出差",
          lo_currency: null,
          lo_rate: 1,
          lo_receivedby: null,
          lo_bank: null,
          lo_bankaccount: null,
          lo_content: null,
        },
      },
    };
  },
  mounted() {
    var me = this,
      main = me.form.main;
    if (!main.id) {
      // 自动获取银行账号
      me.getCurrentUserInfo().then(function (info) {
        if (info) {
          main.lo_receivedby = info.em_name;
          main.lo_bank = info.em_bank;
          main.lo_bankaccount = info.em_bankaccount;
        }
      });
    }
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.lo_receivedby) {
        me.$weui.topTips("请填写收款人名称", 2000);
      } else if (!main.lo_currency) {
        me.$weui.topTips("请填写币种", 2000);
      } else if (!main.lo_bank) {
        me.$weui.topTips("请填写开户银行", 2000);
      } else if (!main.lo_bankaccount) {
        me.$weui.topTips("请填写银行账号", 2000);
      } else if (!main.lo_content) {
        me.$weui.topTips("请填写借款用途", 2000);
      } else {
        me.p_save();
      }
    },
    getCurrentUserInfo() {
      var me = this;
      return me
        .$ajax({
          url: "/api/document/employee/read/current",
        })
        .then(function (res) {
          if (res.success && res.data) {
            return res.data.main;
          }
        });
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.lo_rate = selection.cr_rate;
    },
  },
};
</script>